class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.isOpening = false; // Açılış durumu flag'i
    this.activeObservers = []; // Aktif observer'ları sakla

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    if (this.querySelector('button[type="button"]') != null) {
      this.querySelector('button[type="button"]').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    }
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation(); // Click'in body'ye yayılmasını engelle
    const details = this.detailsContainer;
    if (details) {
      if (details.hasAttribute('open')) {
        this.close();
      } else {
        // Açılış durumunu aktif et (body click'i engelle)
        this.isOpening = true;

        // Details'i aç
        details.setAttribute('open', 'true');


        // Predictive search'ü kontrol et ve kilitle
        const predictiveSearch = this.querySelector('predictive-search');
        if (predictiveSearch) {
          if (!predictiveSearch.hasAttribute('open')) {
            predictiveSearch.setAttribute('open', 'true');
          }
        }

        this.open(event);
      }
    }
  }
 

  onBodyClick(event) {
  
    // Summary'ye tıklandıysa hiçbir şey yapma (toggle zaten oluyor)
    if (event.target.closest && event.target.closest('summary')) {
      return;
    }

    const isMobile = window.innerWidth < 990;
    const desktopSearchBar = this.querySelector('.desktop-search-bar');
    const mobileSearchModal = this.querySelector('.search-modal');

    // Mobilde: Sadece close button'a tıklanınca kapat
    if (isMobile && mobileSearchModal) {
      // Close button'a tıklandıysa kapat (zaten constructor'da listener var)
      // Diğer tüm tıklamalarda hiçbir şey yapma
      return;
    }

    // Desktop'ta: desktop-search-bar dışına tıklanınca kapat
    if (desktopSearchBar) {
      // desktop-search-bar içindeki elementlere tıklandıysa kapanmayı engelle
      if (desktopSearchBar.contains(event.target)) {
        return;
      }
      // desktop-search-bar dışına tıklanmışsa kapat
      this.close(false);
    }
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    // Body click listener'ı hemen ekle
    document.body.removeEventListener('click', this.onBodyClickEvent, true);
    document.body.addEventListener('click', this.onBodyClickEvent, true);

    setTimeout(() => {
      this.isOpening = true;
    }, 1500);

    // Scroll pozisyonunu kaydet ve body'yi sabitle
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.classList.add('overflow-hidden');
    const sticky = document.querySelector('sticky-header');
    sticky.style.position = 'fixed';
    sticky.style.top = '0';
    sticky.style.width = '100%';
    const searchInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => {
      document.documentElement.style.overflow = 'hidden';
    }, 10);
    setTimeout(() => {
      document.documentElement.style.overflow = 'hidden';
    }, 20);
    setTimeout(() => {
      document.documentElement.style.overflow = 'hidden';
    }, 30);
    setTimeout(() => {
      document.documentElement.style.overflow = 'hidden';
    }, 40);
    setTimeout(() => {
      document.documentElement.style.overflow = 'hidden';
    }, 50);
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      searchInput
    );

    // Predictive search için - input'a focus yapıldığında otomatik olarak açılacak
    // Focus event'i predictive-search'ün onFocus metodunu tetikleyecek
    if (searchInput) {
      // Focus'tan önce küçük bir gecikme ekle
      setTimeout(() => {
        searchInput.focus();
      }, 150);
    }
  }

  close(focusToggle = true) {
    // Açılış durumunu sıfırla
    this.isOpening = false;

    // Tüm aktif observer'ları durdur (kilidi kaldır)
    this.activeObservers.forEach(observer => observer.disconnect());
    this.activeObservers = [];

    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    // Predictive search attribute'larını temizle
    const predictiveSearch = this.querySelector('predictive-search');
    if (predictiveSearch) {
      predictiveSearch.removeAttribute('results');
      predictiveSearch.removeAttribute('open');
    }

    // Details'i kapat
    this.detailsContainer.removeAttribute('open');

    document.body.removeEventListener('click', this.onBodyClickEvent, true);
    document.body.classList.remove('overflow-hidden');

    // Scroll pozisyonunu geri yükle
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    const sticky = document.querySelector('sticky-header');
    sticky.style.position = '';
    sticky.style.top = '';
    sticky.style.width = '';
    document.documentElement.style.overflow = '';
    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }
}

customElements.define('details-modal', DetailsModal);